import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logo_footer from '../images/footer_sereslatam.png';

const Footer = () => {
    const thisYear = new Date().getFullYear();
    return (
        <footer className='bg-tertiary text-white'>
            <Container>
                <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className='mb-3 mt-5'>
                        <h3 className='heading3'>SeresLatam</h3>
                        <p>
                            <strong>Te acompañamos en la construcción de un futuro sólido.</strong>&nbsp;
                            Nuestro servicio, nos convierte en el socio ideal para organizaciones que desean&nbsp;
                            <strong>anticiparse, adaptarse y prosperar.</strong>
                        </p>
                    </Col>
                    <Col lg={4} md={4} sm={12} xs={12}  className='mb-3 mt-5'>
                    </Col>
                    <Col lg={4} md={4} sm={12} xs={12}  className='mb-3 mt-5'>
                        <h3 className='heading3'>Mapa Del Sitio</h3>
                        <ul className='list-arrow'>
                            <li><a href="#home">Inicio</a></li>
                            <li><a href='#whatwedo'>¿Que hacemos?</a></li>
                            <li><a href='#nuestroservicio'>Nuestro Servicio</a></li>
                            <li><a href='#ourclients'>Clientes</a></li>
                            <li><a href='https://consultores.sereslatam.com'>Consultores</a></li>
                        </ul>
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col lg={6} md={6} sm={12} xs={12}  className='mb-3 mt-3'>
                        <img src={logo_footer} alt="Logo SeresLatam" className='logo-footer' />
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}  className='mb-3 mt-3'>
                        <p className='text-end'>© {thisYear} SeresLatam. Todos los derechos reservados.</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;